// tslint:disable:max-classes-per-file
var CarrierGroup = /** @class */ (function () {
    function CarrierGroup() {
        this.id = '';
        this.name = '';
        this.description = '';
        this.carriers = [];
        this.isDeleted = false;
    }
    return CarrierGroup;
}());
export { CarrierGroup };
var SaveCarrierGroup = /** @class */ (function () {
    function SaveCarrierGroup() {
        this.id = '';
        this.name = '';
        this.description = '';
    }
    return SaveCarrierGroup;
}());
export { SaveCarrierGroup };
